import React from 'react';

const CreateImpact = () => {
  return (
    <div className="w-full bg-white py-8 sm:py-12 md:py-16 lg:py-20">
      <div className="max-w-full mx-auto px-4 sm:px-6 md:px-8 lg:px-8">
        {/* Title Section */}
        <div className="text-center lg:text-left mb-8 sm:mb-12 md:mb-16 max-w-7xl mx-auto">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-semibold font-source text-[#113861] mb-3 sm:mb-4 leading-tight">
            Create Impact
          </h1>
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-normal italic font-source text-[#113861] leading-tight">
            Where It Matters Most
          </h2>
        </div>
        
        {/* Mobile/Tablet Image Container */}
        <div className="lg:hidden flex justify-center mb-8 sm:mb-12">
          <img 
            src="/images/impact.png" 
            alt="Create Impact 3D Graphic" 
            className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 object-contain"
            style={{
              filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.15))',
              width: '70%',
              height: '70%',
              objectFit: 'contain',
              objectPosition: 'bottom',
              marginBottom: '30px',
            }}
          />
        </div>

        {/* Desktop Image Container */}
        <div className="hidden lg:block relative z-0">
            <div className="absolute"
            style={{
              top: '60px',
              left:'70px',
              width:'45%',
              objectFit:'contain',
              objectPosition:'bottom',
            }}
            >
              <img 
                src="/images/impact.png" 
                alt="Create Impact 3D Graphic" 
                className="w-full h-full object-contain object-bottom"
                style={{
                  bottom: '-90px',
                  left: '-100px',
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  objectPosition: 'bottom',
                }}
              />
            </div>
          </div>
        
        {/* Main Content Container */}
        <div className="relative min-h-[400px] sm:min-h-[450px] md:min-h-[500px] lg:min-h-[700px] max-w-7xl mx-auto">
          {/* Text Content - Positioned above the prism */}
          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 md:gap-10 lg:gap-16 mb-8 sm:mb-12 md:mb-16">
            {/* Left Column */}
            <div className="space-y-4 sm:space-y-5 md:space-y-6 text-center lg:text-left">
              <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl font-sans font-regular text-[#2b2b2b] leading-relaxed max-w-lg sm:max-w-xl md:max-w-2xl mx-auto lg:mx-0">
                At Analytical Prism, we believe clarity should be accessible to all. Our work in the social sector brings psychometric assessments and cognitive science to the communities that need it most.
              </p>
            </div>

            {/* Right Column */}
            <div className="space-y-4 sm:space-y-5 md:space-y-6 text-center lg:text-left">
              <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl font-sans font-regular text-[#2b2b2b] leading-relaxed max-w-lg sm:max-w-xl md:max-w-2xl mx-auto lg:mx-0">
                Through collaborations with NGOs, educational charities, and grassroots initiatives, we provide evidence-based tools that support career clarity, life skills, and self-awareness in underserved populations. From school interventions to youth mentorship, we help create pathways from uncertainty to opportunity, one clear decision at a time.
              </p>
            </div>
          </div>

          {/* Prism Image - Positioned in bottom left */}
         
        </div>
      </div>
    </div>
  );
};

export default CreateImpact;
